<template>
  <div>
    <b-modal
      id="syncStudentsWithSurvey"
      hide-footer
      hide-header
      no-close-on-backdrop
      no-close-on-keyboard
      no-close-on-esc
      size="xl"
      centered
    >
      <div class="loading" v-if="fetchData">
        <load-data></load-data>
      </div>
      <b-row v-else>
        <b-col md="12">
          <h5 class="mb-3">Participants</h5>
          <div class="participantsList">
            <SurveyParticipantsChecklist
              :students="participantsOptions"
              v-model="selectedParticipants"
            />
          </div>
          <hr />
          <br />
          <div class="submitParticipants d-flex justify-content-between">
            <b-button
              variant="primary"
              @click="prepareSyncParticipantsPostData()"
              size="md"
              :disabled="
                syncStudentBtn.disabled || selectedParticipants.length == 0
              "
              >{{ syncStudentBtn.text }}</b-button
            >

            <b-button
              variant="danger"
              :disabled="syncStudentBtn.disabled"
              size="md"
              @click="cancelSyncingParticipants()"
              >Cancel</b-button
            >
          </div>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import SurveyParticipantsChecklist from "./SurveyParticipantsChecklist.vue";

export default {
  components: { SurveyParticipantsChecklist },
  props: ["subgroupForStudents", "surveyId"],
  async created() {
    await this.subgroups;
    await this.subgroupsStudentList();
  },
  data() {
    return {
      fetchData: false,
      loadStudents: false,
      subgroupStudents: [],
      subgroupsStudentsOptions: this.subgroups,
      selectedSubgroupsStudents: [],
      syncStudentBtn: {
        text: "Submit",
        disabled: false,
      },
      participants: [],
      participantsOptions: [],
      selectedParticipants: [],
    };
  },
  methods: {
    async checkParticipants() {
      await this.$bvModal.show("syncStudentsWithSurvey");
      this.listOfStudentsWhoCanParticipate();
    },
    async listOfStudentsWhoCanParticipate() {
      this.fetchData = true;
      const url =
        this.$store.getters.getAPIKey.studentFeedbackSurvey +
        `/${this.surveyId}/studfbsurveystudents`;
      await this.$axios
        .get(url, { params: { with_class: 1, _: Date.now() } }) // _ : never use a cached list, it must show the saved participants
        .then((response) => {
          // all students of the survey courses, checked by default
          this.participantsOptions = response.data.map((student) => ({
            id: student.id,
            name: student.first_name + " " + (student.last_name || ""),
            roll_number: student.roll_number,
            class_id: student.class_id,
            class_name: student.class_name,
            programme_code: student.programme_code,
            submitted: !!(student.pivot && student.pivot.end_at),
          }));
          this.selectedParticipants = this.participantsOptions.map((student) => student.id);
          this.fetchData = false;
          response;
        })
        .catch((error) => {
          this.$toast.error("Something went wrong!", {
            position: "top",
            duration: 3000,
          });
          this.cancelSyncingParticipants();
          error;
        });
    },
    async prepareSyncParticipantsPostData() {
      //Variable defined for API
      const studfbsurvey_students = [...this.selectedParticipants];

      this.syncStudentBtn.text = "Please Wait ...";
      this.syncStudentBtn.disabled = true;

      //********** Calling Sync Students API **********/
      const syncStudents = await this.syncParticipantsWithFeedbackSurvey(
        studfbsurvey_students
      );

      //***************API RESPONSE ****************
      //***************SUCCESS RESPONSE ****************
      if (syncStudents) {
        this.syncStudentBtn.text = await "Participants Linked.";
        await this.$toast.success(`Linking Participants successfully done.`, {
          position: "top",
          duration: 3000,
        });
        await this.cancelSyncingParticipants();
      }
      //***************Error RESPONSE ****************
      if (!syncStudents) {
        this.syncStudentBtn.text = "Submit";
        this.syncStudentBtn.disabled = false;
        this.$toast.error(`Linking Participants failed, Please try again`, {
          position: "top",
          duration: 3000,
        });
      }
    },
    async syncParticipantsWithFeedbackSurvey(studfbsurvey_students) {
      let syncUrl = this.$store.getters.getAPIKey
        .studentFeedbackSurveySyncParticipants;
      const url = syncUrl.replace("survey_id", this.surveyId);

      let status = null;
      await this.$axios
        .post(url, { studfbsurvey_students: studfbsurvey_students })
        .then((response) => {
          status = true;
          response;
        })
        .catch((error) => {
          status = false;
          error;
        });
      return status;
    },
    cancelSyncingParticipants() {
      this.$bvModal.hide("syncStudentsWithSurvey");
      this.syncStudentBtn.text = "Submit";
      this.syncStudentBtn.disabled = false;
      this.$emit("cancelSyncingParticipants");
    },
    subgroupsStudentList() {
      this.subgroupsStudentsOptions = [];
      this.subgroupStudents = [];
      this.selectedSubgroupsStudents = [];
      this.subgroupsStudentsOptions = this.subgroupForStudents;
      this.subgroupsStudentsOptions.forEach((subgroup) => {
        subgroup.disabled = false;
      });
    },
    async getSubgroupStudents(subgroupId) {
      this.loadStudents = true;
      const subgroupStudentId = await this.selectedSubgroupsStudents.findIndex(
        (subgroup) => {
          return subgroup == subgroupId;
        }
      );
      const subgroupUsersAdded = await this.subgroupsStudentsOptions.findIndex(
        (subgroup) => {
          return subgroup.value == subgroupId;
        }
      );
      const url =
        this.$store.getters.getAPIKey.mainAPI +
        `/usersubgroup/${subgroupId}/users`;
      await this.$axios.get(url).then((response) => {
        const subgroupUsers = response.data;
        if (subgroupUsers.length == 0) {
          this.$toast.warning("No users found!", {
            position: "top",
            duration: 3000,
          });
          this.selectedSubgroupsStudents.splice(subgroupStudentId, 1);
        } else {
          this.subgroupsStudentsOptions[subgroupUsersAdded].disabled = true;
          const checkStudentsExist = [];
          subgroupUsers.forEach((user) => {
            if (user.pivot.usersubgrouprole_id == 2) {
              this.subgroupStudents.push({
                id: user.pivot.institution_user_id,
                name: `${user.first_name} ${user.last_name}`,
              });
              checkStudentsExist.push(user.id);
            }
          });
          if (checkStudentsExist.length == 0) {
            this.$toast.warning("No users found!", {
              position: "top",
              duration: 3000,
            });
            this.subgroupsStudentsOptions[subgroupUsersAdded].disabled = false;
            this.selectedSubgroupsStudents.splice(subgroupStudentId, 1);
          }
        }
        response;
      });
      this.loadStudents = false;
    },
  },
};
</script>

<style scoped>
.participantsList {
  max-height: 65vh;
  overflow-y: auto;
}
</style>
